module.exports = __webpack_public_path__ + "img/fallback-image.dc4f88da.svg";